import { render, staticRenderFns } from "./ButtonSimple.vue?vue&type=template&id=09b5ffe3&scoped=true"
import script from "./ButtonSimple.vue?vue&type=script&lang=ts"
export * from "./ButtonSimple.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSimple.vue?vue&type=style&index=0&id=09b5ffe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b5ffe3",
  null
  
)

export default component.exports